<fin-corporate-widget [imageFromFragment]="'fragments.compensateChooose'">
  <h4 class="font-heading-4 ms-large-b">{{ 'CORPORATE.corporatePortal.widgets.safWidget.title' | finLocalization }}</h4>
  <p
    class="font-body-2 medium-type"
    [innerHTML]="'CORPORATE.corporatePortal.widgets.safWidget.description' | finLocalization | finSafe: 'html'"
  ></p>
  <div class="flex flex--end ps-medium-t">
    <fcom-button
      class="ms-medium-r"
      [text]="'CORPORATE.corporatePortal.widgets.safWidget.readMore' | finLocalization"
      [theme]="ButtonTheme.LIGHT_TERTIARY_GHOST"
      (clickBtn)="goToReadMore()"
    ></fcom-button>
    @if (hasSafPermission$ | async) {
      <fcom-button
        [text]="'CORPORATE.corporatePortal.widgets.safWidget.viewEmissions' | finLocalization"
        [theme]="ButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE"
        [loading]="loading"
        (clickBtn)="goToChooose()"
        data-testid="saf-widget-view-emissions"
      ></fcom-button>
    } @else if ((hasSafPermission$ | async) === false) {
      <fcom-button
        [text]="'CORPORATE.corporatePortal.widgets.safWidget.activate' | finLocalization"
        [theme]="ButtonTheme.LIGHT_PRIMARY_CTA_HEATHER"
        [loading]="loading"
        [aria]="{ loadingLabel: 'actions.loading' | finLocalization }"
        (clickBtn)="goToChooose()"
        data-testid="saf-widget-activate"
      ></fcom-button>
    }
  </div>
</fin-corporate-widget>

<fin-saf-terms
  #safTerms
  [hasSafPermission$]="hasSafPermission$"
  (termsUpdated)="termsUpdated()"
  (completed)="loading = false"
></fin-saf-terms>
